var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lenders.length)?_c('div',{staticClass:"lender-grid grid-x grid-margin-x",class:_vm.computedGridClassNames},_vm._l((_vm.lenders),function(lender){return _c('LenderBlock',{key:lender.id,staticClass:"cell",attrs:{"lender":lender}})}),1):_c('p',{staticClass:"no-lenders",domProps:{"innerHTML":_vm._s(_vm.noDataMessage)}})
}
var staticRenderFns = []

export { render, staticRenderFns }